export function createDoubleButton({ href, mainText, icon, className }) {
  return `
  <a class="doubleButton_wrapper ${className ?? ''}" href="${href}">
    <div class="btn_primary_text doubleButton_main">${mainText}</div>
    <div class="round_btn">
    ${icon}
    </div>
  </a>`
}
